import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController } from 'ionic-angular';
import { LangPage } from '../lang/lang';
import { InfoPage } from '../info/info';
import { EnregistrerPage } from '../enregistrer/enregistrer';
import { MedicamentsPage } from '../medicaments/medicaments';
import { JournalPage } from '../journal/journal';
import { StatistiquesPage } from '../statistiques/statistiques';
import { EcrirePage } from '../ecrire/ecrire';
import { ConseilsPage } from '../conseils/conseils';
import { MalPage } from '../mal/mal';

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  showButtons = false;
  head_title = "";

  items = [
    {
      title:"Enregistrer",
      icon:"body",
      class:"col-6",
      page: EnregistrerPage
    },
    {
      title:"Médicaments",
      icon:"medical",
      class:"col-6",
      page: MedicamentsPage
    },
    {
      title:"Statistiques",
      icon:"stats",
      class:"col-6",
      page: StatistiquesPage
    },
    {
      title:"Journal",
      icon:"pulse",
      class:"col-6",
      page: JournalPage
    },
    {
      title:"Écrire",
      icon:"create",
      class:"col-6",
      page: EcrirePage
    },
    {
      title:"Conseils",
      icon:"chatboxes",
      class:"col-6",
      page: ConseilsPage
    },{
    title:"J'ai mal",
    icon:"hand",
    class:"col-12",
    page: MalPage
    }
  ];

  titles = [
    "Comment tu te sens aujourd'hui ?",
    "Comment vas-tu aujourd'hui ?"
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private popoverCtrl: PopoverController
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomePage');
    let random_key = Math.floor(Math.random() * this.titles.length);
    this.head_title = this.titles[random_key];
  }

  goTo(i){
    this.navCtrl.push(this.items[i].page,{});
  }


  goToInfo(){
    this.navCtrl.push(InfoPage);
  }


  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(LangPage);
    popover.present({
      ev: myEvent
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts